import React, { Component } from 'react';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import Router from '@dbk-legacy/muster/react-router';
import { getRoutes } from './app.routes';
import config from '../../data/get-settings';
import delay from '../../utils/delay';

// Do we really need it ?
const element = document.getElementById('loggedInUserEmail');
const isInternalElement = document.getElementById('isInternal');
const isWebssoInternal =
  isInternalElement != null ? isInternalElement.value : null;

// != null tests agains null and undefined. if u want to test only agains one !`==`;
// const objNotNullOrUndefined = (obj) => obj != null;
// const objsNotNullOrUndefined = (...args) => args.every(objNotNullOrUndefined);

// const idConnect = () => objsNotNullOrUndefined(jwt, user, ret);

class PreLoginApp extends Component {
  async componentDidMount() {
    const {
      auth: { authorised },
      changePage,
      marque: { loginDissmiss },
      languages: { getlanguages },
    } = this.props;

    this.props.getconfig();

    this.props.initWindow();
    // get lang and langCode from localStorage,
    // if there is not, set default to English
    getlanguages()

    // if (idConnect()) {
    //   changePage('/idconnect');
    //   return;
    // }

    if (isWebssoInternal) {
      changePage('/webssoconnect');
      return;
    }

    const currentURL = this.props.ui.history.currentLocation.pathname;
    const authBypass = config.authbypass.filter((bypassUrl) => !authorised && currentURL.indexOf(bypassUrl) >= 0).length > 0;

    if (!authBypass) {
      await delay(300);
      if (!isWebssoInternal) {
        changePage('/login')
      }
    }
  }

  render() {
    const routesConfig = getRoutes(this.props);

    return (
      <View >
        <Router webfolder={config.webfolder} config={routesConfig} />
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    initWindow: { $call: 'screen.update' },
    screen: {
      isSmall: true,
    },
    getconfig: { $call: 'app.getConfig' },
    auth: {
      authorised: true,
      entitlement: true,
      dashboardAuthorised: true,
      passwordExpired: true,
      isNonActivePortfolio: true,
      vascoFlow: true,
      isAdminUser: true,
      entitlementProcessed: true,
      langCode: true
    },
    config: {
      regionCode: true,
    },
    marque: {
      loginDissmiss: true,
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
        },
      },
    },
    languages: {
      getlanguages: { $call: 'getlanguages' },
    },
    ui: {
      history: {
        currentLocation: { pathname: true, route: true },
      }
    },
    rsa: {
      onChangePage: { $call: 'changePage' },
      rsaAuthorised: true
    },
    vascoauthentication: {
      vascoAuthorised: true
    },
  },
})(PreLoginApp);
